import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSnapshotSpiderDashboardController from 'lumen/controllers/hotel/snapshot/spider-dashboard';
import type HotelRoute from 'lumen/routes/hotel';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import type { ModelFrom } from 'lumen/utils/routes';
import { SNAPSHOT_PATHS } from 'lumen/utils/spider';

type Model = ModelFrom<HotelRoute>;

type Params = {
  path: string;
};

@protectedRoute({ features: ['spider.hotel_snapshot'] })
export default class HotelSnapshotSpiderDashboardRoute extends Route {
  @service declare router: Services['router'];

  dashboard: string | undefined = undefined;

  get extendedRouteName(): string {
    const { path } = this.paramsFor('hotel.snapshot.spider-dashboard') as {
      path: string;
    };

    return this.fullRouteName.replace('spider-dashboard', path);
  }

  beforeModel(): void {
    const { path } = this.paramsFor('hotel.snapshot.spider-dashboard') as {
      path: string;
    };

    if (!SNAPSHOT_PATHS.includes(path)) {
      this.router.replaceWith(
        'hotel.snapshot.spider-dashboard',
        SNAPSHOT_PATHS[0],
      );
    }
  }

  model(params: Params): Model {
    /**
     * Stored `path` as a class property, because returning it from
     * the `model` hook will trigger a refresh when `path` changes.
     *
     * Spider handles changing routes. It will send a message to
     * update the URL.
     */
    this.dashboard = params.path;

    return this.modelFor('hotel') as Model;
  }

  setupController(controller: HotelSnapshotSpiderDashboardController): void {
    // @ts-expect-error: A spread argument must either have a tuple type or be passed to a rest parameter.
    // eslint-disable-next-line prefer-rest-params
    super.setupController(...arguments);

    controller.dashboard = this.dashboard!;
  }
}
